import { Component, Inject } from '@angular/core';
import { CommonModule } from '@angular/common';
import { MAT_DIALOG_DATA, MatDialogRef, MatDialogModule, MatDialog } from '@angular/material/dialog';
import { MatButtonModule } from '@angular/material/button';
import { Observable } from 'rxjs';

export interface ConfirmationDialogData {
  title: string;
  message: string;
  confirmText?: string;
  cancelText?: string;
  confirmColor?: 'primary' | 'accent' | 'warn';
}

@Component({
  selector: 'app-confirmation-dialog',
  standalone: true,
  imports: [CommonModule, MatDialogModule, MatButtonModule],
  templateUrl: './confirmation-dialog.component.html',
  styleUrls: ['./confirmation-dialog.component.css']
})
export class ConfirmationDialogComponent {
  constructor(
    public dialogRef: MatDialogRef<ConfirmationDialogComponent>,
    @Inject(MAT_DIALOG_DATA) public data: ConfirmationDialogData
  ) {}

  onCancel(): void {
    this.dialogRef.close(false);
  }

  onConfirm(): void {
    this.dialogRef.close(true);
  }

  // Static methods for easy usage
  static open(dialog: MatDialog, data: ConfirmationDialogData): Observable<boolean> {
    const dialogRef = dialog.open(ConfirmationDialogComponent, {
      width: '400px',
      disableClose: true,
      data: data
    });

    return dialogRef.afterClosed();
  }

  static confirmDelete(dialog: MatDialog, itemName: string = 'item'): Observable<boolean> {
    return this.open(dialog, {
      title: 'Confirm Delete',
      message: `Are you sure you want to delete ${itemName}? This action cannot be undone.`,
      confirmText: 'Delete',
      cancelText: 'Cancel',
      confirmColor: 'warn'
    });
  }

  static confirmAction(dialog: MatDialog, action: string, itemName: string = 'item'): Observable<boolean> {
    return this.open(dialog, {
      title: 'Confirm Action',
      message: `Are you sure you want to ${action} this ${itemName}?`,
      confirmText: action.charAt(0).toUpperCase() + action.slice(1),
      cancelText: 'Cancel',
      confirmColor: 'primary'
    });
  }
}
